<div class="td-bars" *ngIf="rows.length">
  <div class="td-bar-row" *ngFor="let row of rows; trackBy: trackByTitle">
    <span class="td-bar-label">{{ row.title }}</span>
    <span class="td-bar-track">
      <span class="td-bar-fill" [ngStyle]="{'width.%': row.value, 'background-color': row.color}"></span>
    </span>
    <span class="td-bar-value">{{ row.value }}%</span>
  </div>
</div>
